import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { HeaderVisibilityProvider } from './components/header/context/HeaderVisibilityContext.tsx';
import { LoadingProvider } from './login/context/LoadingContext.tsx';
import { ProductProvider } from './product/context/ProductContext.tsx';
import { UserProvider } from './user/context/UserContext.tsx';

Sentry.init({
  dsn: 'https://e5b719d307e71f53e7b695105526b1c9@o4509231331147776.ingest.us.sentry.io/4509231351267328',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  release: 'rapi-fruti@1.0.0',
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <LoadingProvider>
        <HeaderVisibilityProvider>
          <UserProvider>
            <ProductProvider>
              <App />
            </ProductProvider>
          </UserProvider>
        </HeaderVisibilityProvider>
      </LoadingProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// Unregister service workers (legacy CRA)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}
